module.exports = __webpack_public_path__ + "img/student_default.518ddca7.png";